import { ApiError, errorMessage } from '@/api/errors';

/** `details.reason` values from the date-invite endpoints (ARCHITECTURE §24). */
export function dateInviteError(e: unknown): string {
  if (e instanceof ApiError) {
    const r = e.details.reason;
    switch (r) {
      case 'too_many_open':
        return 'You have 5 open invites. Cancel one in Friends → Dates, or wait for a date first.';
      case 'daily_limit':
        return 'That’s 20 invites today. Try again tomorrow.';
      case 'own_invite':
        return 'This is your own invite — share the link with someone else.';
      case 'taken':
        return 'This invite has been taken.';
      case 'expired':
        return 'This invite has expired.';
      case 'cancelled':
        return 'This invite was cancelled.';
      case 'declined':
        return 'This invite was declined.';
      case 'not_both_here':
        return 'Start once you’re both here.';
      case 'no_guest':
        return 'Nobody has accepted this invite yet.';
      case 'in_session':
        return 'Finish your current call first.';
      case 'peer_in_session':
        return 'They’re in another call right now.';
      case 'in_call':
        return 'You’re on this date right now.';
      case 'not_onboarded':
        return 'Finish setting up your profile first.';
      case 'not_picked':
        return 'They haven’t said that time works — pick one they chose.';
      case 'slot_passed':
        return 'That time has passed — offer new times.';
      case 'not_scheduled':
        return 'Pick a time first.';
    }
    if (e.code === 'feature_disabled') return 'Popin Dates isn’t available right now.';
    if (e.code === 'validation_failed' && e.field === 'note') return e.message;
    if (e.code === 'validation_failed' && e.field === 'starts_at') return 'Pick a time within the next 7 days.';
    if (e.code === 'validation_failed' && (e.field === 'slots' || e.field === 'suggested' || e.field === 'slots_ok')) return e.message;
    if (e.status === 404) return 'This invite isn’t available.';
  }
  return errorMessage(e);
}

/** The reason an invite link can't be accepted, for the public page's states. */
export function inviteReason(e: unknown): string | null {
  if (e instanceof ApiError) {
    const r = e.details.reason;
    return typeof r === 'string' ? r : e.status === 404 ? 'not_found' : null;
  }
  return null;
}
